var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import './styles/main0.scss';
import './styles/welcome.scss';
import './styles/global.scss';
import axios from 'axios';
import $ from 'jquery';
import { LocalDevice } from './Devices/LocalDevice';
import pkg from '../package.json';
var version = pkg.version;
var crossLogin = "https://michmond.com/api/account/cross-login";
var serviceProvider = "https://drive.michmond.com/api/login";
axios.defaults.withCredentials = true;
function LogIn() {
    return __awaiter(this, void 0, void 0, function () {
        var userName, userPass, formData, respLogin, serverList, storageForm, i, serverUrl, s;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    $(".form").addClass("loading");
                    UnsetError();
                    userName = $("input[name=user]").val();
                    userPass = $("input[name=pass]").val();
                    formData = {
                        u: userName,
                        p: userPass,
                        method: "session",
                        client_browser: LocalDevice.getBrowser(),
                        client: LocalDevice.getClient(),
                        client_version: version,
                    };
                    return [4 /*yield*/, axios.post("/api/login", formData)];
                case 1:
                    respLogin = _a.sent();
                    console.warn("data", respLogin.data[0]);
                    if (!(respLogin.status == 202)) return [3 /*break*/, 6];
                    $(".form button").addClass("ok");
                    serverList = respLogin.data.activeServers;
                    storageForm = { u: userName, p: userPass, method: "session" };
                    i = 0;
                    _a.label = 2;
                case 2:
                    if (!(i < serverList.length)) return [3 /*break*/, 5];
                    serverUrl = "https://" + serverList[i] + "/api/login";
                    if (serverUrl == serviceProvider)
                        return [3 /*break*/, 4];
                    return [4 /*yield*/, axios.post(serverUrl, storageForm).catch(function (error) { console.log(error); })];
                case 3:
                    s = _a.sent();
                    if (!s || s.status != 202)
                        console.error("Login Error (storage provider #".concat(i, ")"), serverUrl);
                    _a.label = 4;
                case 4:
                    i++;
                    return [3 /*break*/, 2];
                case 5:
                    window.location.href = "/";
                    return [3 /*break*/, 7];
                case 6:
                    $(".form").removeClass("loading");
                    if (respLogin.data == "data_w")
                        SetError("Wrong email or password!");
                    else if (respLogin.data == "data_u")
                        SetError("Please enter your email!");
                    else
                        SetError("Please enter your credentials!");
                    _a.label = 7;
                case 7: return [2 /*return*/];
            }
        });
    });
}
function UnsetError() { }
function SetError(text) {
    //alert(text);
}
$("button[name=do-login]").on("click", function () { LogIn(); });
$("#login .tab>p").on("click", function () { $("#login .tab ").toggleClass("active"); });
var serversOnline = 0;
var serversLs = {};
var Server = /** @class */ (function () {
    function Server(data) {
        this.data = data;
        $("#server-list>div").append("\n            <div data-id=\"".concat(data.id, "\" class=\"server\">\n                <span class=\"id\">#").concat(data.id, "</span>\n                <span><i class=\"fa-solid fa-globe\"></i> ").concat(data.ip, "</span>\n                <i class=\"fa-solid fa-location-dot\"></i> ").concat(data.location_country + "-" + data.location_regon, " </div>"));
    }
    Server.prototype.GetStatus = function () {
        return __awaiter(this, void 0, void 0, function () {
            var jq, now, time, result, upLimit, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        jq = $("#server-list .server[data-id=" + this.data.id + "]");
                        now = Date.now();
                        time = (now / 1000 - this.data.connection_last) / 60;
                        if (!(time < 4)) return [3 /*break*/, 4];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, axios.get("https://" + this.data.address + "/api/server/status.php")];
                    case 2:
                        result = _a.sent();
                        upLimit = result.data["max_upload"] / 1024 / 1024;
                        jq.append("".concat(this.data.status, "\n                    <div>\n                    <span><i class=\"fa-solid fa-signal\"></i> ").concat((Date.now() - now), "ms</span>\n                    <span><i class=\"fa-solid fa-file-arrow-up\"></i> ").concat(upLimit > 2000 ? upLimit / 1024 + " GB" : upLimit + " MB", "</span>\n                    </div>"));
                        jq.addClass("ok");
                        serversOnline++;
                        $("#form > p > span").text(serversOnline + "/" + Object.keys(serversLs).length);
                        console.log("Server #".concat(this.data.id, " ping: ").concat((Date.now() - now), "ms"));
                        return [2 /*return*/];
                    case 3:
                        err_1 = _a.sent();
                        console.warn("Server connection error (#".concat(this.data.id, ")"));
                        return [3 /*break*/, 4];
                    case 4:
                        if (time > 60 * 48)
                            time = (time / 60 / 24).toFixed() + " days";
                        else if (time > 60)
                            time = (time / 60).toFixed() + " hours";
                        else
                            time = time.toFixed() + " minutes";
                        jq.append("".concat(this.data.status == "online" ? "offline" : this.data.status, "<span><i class=\"fa-solid fa-heart-pulse\"></i> online: ").concat(time, " ago</span>"));
                        jq.addClass("error");
                        return [2 /*return*/];
                }
            });
        });
    };
    Server.prototype.LogIn = function () {
    };
    return Server;
}());
function GetServersStatus() {
    return __awaiter(this, void 0, void 0, function () {
        var serverListRequest, _i, _a, id;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, axios.post("https://drive.michmond.com/server/getList")];
                case 1:
                    serverListRequest = _b.sent();
                    serverListRequest.data.forEach(function (data) { serversLs[data.id] = new Server(data); });
                    $("#form > p > span").text("0/" + Object.keys(serversLs).length);
                    _i = 0, _a = Object.keys(serversLs);
                    _b.label = 2;
                case 2:
                    if (!(_i < _a.length)) return [3 /*break*/, 5];
                    id = _a[_i];
                    return [4 /*yield*/, serversLs[id].GetStatus()];
                case 3:
                    _b.sent();
                    _b.label = 4;
                case 4:
                    _i++;
                    return [3 /*break*/, 2];
                case 5: return [2 /*return*/];
            }
        });
    });
}
var michmondUser = null;
function CheckCrossLogin() {
    return __awaiter(this, void 0, void 0, function () {
        var rquid;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, axios.post(crossLogin, { action: "getActive" })];
                case 1:
                    rquid = _a.sent();
                    if (rquid.status != 201 || rquid.data == null)
                        return [2 /*return*/, false];
                    michmondUser = rquid.data;
                    $("#login-content #form h2").css("opacity", 0);
                    $("#box").prepend("<button id=\"cross-user\"><img src=\"/assets/img/user-default.svg\"><div><span>Found MichmondID</span><br>".concat(rquid.data.nick, "</div></button>"));
                    $("#cross-user").on("click", function () {
                        DoCrossLogin();
                    });
                    return [2 /*return*/];
            }
        });
    });
}
function DoCrossLogin() {
    return __awaiter(this, void 0, void 0, function () {
        var clRequest;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!michmondUser)
                        return [2 /*return*/];
                    return [4 /*yield*/, axios.post(crossLogin, { action: "getToken", uid: michmondUser.id })];
                case 1:
                    clRequest = _a.sent();
                    if (clRequest.status != 201)
                        return [2 /*return*/, console.warn("CheckCrossLogin: TK ERROR")];
                    console.warn("TK: " + clRequest.data);
                    return [2 /*return*/];
            }
        });
    });
}
GetServersStatus();
//CheckCrossLogin();
var footer = $("footer");
$("footer button").on({
    click: function () {
        window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    },
    mouseenter: function () {
        footer.addClass("color");
    },
    mouseleave: function () {
        footer.removeClass("color");
    },
});
var footerBg = false;
var loginBox = $("#login");
$(window).scroll(function () {
    var top = $(window).scrollTop();
    var h = $(window).height();
    var docW = $(window).width();
    var docH = $(document).height();
    if (!(top && h && docW && docH))
        return;
    var scrollPos = top + h;
    loginBox.css("transform", "translateY(" + (-top / 4) + "px)");
    loginBox.css("border-radius", docW >= 768 ? "0 0 0 " + (top / h) * 64 + "px" : 0);
    loginBox.css("opacity", 1.2 - (top / h));
    // footer
    if (footerBg) {
        scrollPos += window.innerHeight / 3;
        if (scrollPos < docH) {
            footer.removeClass("bottom");
            footerBg = false;
        }
    }
    else {
        scrollPos += window.innerHeight / 10;
        if (scrollPos > docH) {
            footer.addClass("bottom");
            footerBg = true;
        }
    }
});
